import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesResolutionsDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-resolutions-delete',
	path: '/secure/admin/DeleteResolution!default.jspa',
};
